/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AccountDeletionRouteImport } from './routes/account-deletion'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AppBuddyFinderRouteRouteImport } from './routes/_app/buddy-finder/route'
import { Route as AppCommunityRouteRouteImport } from './routes/_app/community/route'
import { Route as AppDashboardRouteRouteImport } from './routes/_app/dashboard/route'
import { Route as AppMessagesRouteRouteImport } from './routes/_app/messages/route'
import { Route as AppMilestonesRouteRouteImport } from './routes/_app/milestones/route'
import { Route as AppPodsRouteRouteImport } from './routes/_app/pods/route'
import { Route as AppProfileRouteRouteImport } from './routes/_app/profile/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AuthForgotPasswordRouteRouteImport } from './routes/_auth/forgot-password/route'
import { Route as AuthSigninRouteRouteImport } from './routes/_auth/signin/route'
import { Route as AuthSignupRouteRouteImport } from './routes/_auth/signup/route'
import { Route as GoalInviteTokenRouteImport } from './routes/goal-invite/$token'
import { Route as AppGoalsIndexRouteImport } from './routes/_app/goals/index'
import { Route as AppGoalsIdRouteImport } from './routes/_app/goals/$id'
import { Route as AppPodsIndexRouteImport } from './routes/_app/pods/index'
import { Route as AppPodsIdRouteImport } from './routes/_app/pods/$id'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users/$userId'
import { Route as AuthForgotPasswordResetPasswordRouteRouteImport } from './routes/_auth/forgot-password/reset-password/route'
import { Route as AuthForgotPasswordVerifyOtpRouteRouteImport } from './routes/_auth/forgot-password/verify-otp/route'
import { Route as GoalsIdPreviewRouteImport } from './routes/goals/$id/preview'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeletionRoute = AccountDeletionRouteImport.update({
  id: '/account-deletion',
  path: '/account-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBuddyFinderRouteRoute = AppBuddyFinderRouteRouteImport.update({
  id: '/buddy-finder',
  path: '/buddy-finder',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCommunityRouteRoute = AppCommunityRouteRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRouteRoute = AppDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMessagesRouteRoute = AppMessagesRouteRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMilestonesRouteRoute = AppMilestonesRouteRouteImport.update({
  id: '/milestones',
  path: '/milestones',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPodsRouteRoute = AppPodsRouteRouteImport.update({
  id: '/pods',
  path: '/pods',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRouteRoute = AppProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordRouteRoute = AuthForgotPasswordRouteRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSigninRouteRoute = AuthSigninRouteRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignupRouteRoute = AuthSignupRouteRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const GoalInviteTokenRoute = GoalInviteTokenRouteImport.update({
  id: '/goal-invite/$token',
  path: '/goal-invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppGoalsIndexRoute = AppGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGoalsIdRoute = AppGoalsIdRouteImport.update({
  id: '/goals/$id',
  path: '/goals/$id',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPodsIndexRoute = AppPodsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPodsRouteRoute,
} as any)
const AppPodsIdRoute = AppPodsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppPodsRouteRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordResetPasswordRouteRoute =
  AuthForgotPasswordResetPasswordRouteRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthForgotPasswordRouteRoute,
  } as any)
const AuthForgotPasswordVerifyOtpRouteRoute =
  AuthForgotPasswordVerifyOtpRouteRouteImport.update({
    id: '/verify-otp',
    path: '/verify-otp',
    getParentRoute: () => AuthForgotPasswordRouteRoute,
  } as any)
const GoalsIdPreviewRoute = GoalsIdPreviewRouteImport.update({
  id: '/goals/$id/preview',
  path: '/goals/$id/preview',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/buddy-finder': typeof AppBuddyFinderRouteRoute
  '/community': typeof AppCommunityRouteRoute
  '/dashboard': typeof AppDashboardRouteRoute
  '/messages': typeof AppMessagesRouteRoute
  '/milestones': typeof AppMilestonesRouteRoute
  '/pods': typeof AppPodsRouteRouteWithChildren
  '/profile': typeof AppProfileRouteRoute
  '/settings': typeof AppSettingsRouteRoute
  '/forgot-password': typeof AuthForgotPasswordRouteRouteWithChildren
  '/signin': typeof AuthSigninRouteRoute
  '/signup': typeof AuthSignupRouteRoute
  '/goal-invite/$token': typeof GoalInviteTokenRoute
  '/forgot-password/reset-password': typeof AuthForgotPasswordResetPasswordRouteRoute
  '/forgot-password/verify-otp': typeof AuthForgotPasswordVerifyOtpRouteRoute
  '/goals/$id': typeof AppGoalsIdRoute
  '/pods/$id': typeof AppPodsIdRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/goals/$id/preview': typeof GoalsIdPreviewRoute
  '/goals/': typeof AppGoalsIndexRoute
  '/pods/': typeof AppPodsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/buddy-finder': typeof AppBuddyFinderRouteRoute
  '/community': typeof AppCommunityRouteRoute
  '/dashboard': typeof AppDashboardRouteRoute
  '/messages': typeof AppMessagesRouteRoute
  '/milestones': typeof AppMilestonesRouteRoute
  '/profile': typeof AppProfileRouteRoute
  '/settings': typeof AppSettingsRouteRoute
  '/forgot-password': typeof AuthForgotPasswordRouteRouteWithChildren
  '/signin': typeof AuthSigninRouteRoute
  '/signup': typeof AuthSignupRouteRoute
  '/goal-invite/$token': typeof GoalInviteTokenRoute
  '/forgot-password/reset-password': typeof AuthForgotPasswordResetPasswordRouteRoute
  '/forgot-password/verify-otp': typeof AuthForgotPasswordVerifyOtpRouteRoute
  '/goals/$id': typeof AppGoalsIdRoute
  '/pods/$id': typeof AppPodsIdRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/goals/$id/preview': typeof GoalsIdPreviewRoute
  '/goals': typeof AppGoalsIndexRoute
  '/pods': typeof AppPodsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_app/buddy-finder': typeof AppBuddyFinderRouteRoute
  '/_app/community': typeof AppCommunityRouteRoute
  '/_app/dashboard': typeof AppDashboardRouteRoute
  '/_app/messages': typeof AppMessagesRouteRoute
  '/_app/milestones': typeof AppMilestonesRouteRoute
  '/_app/pods': typeof AppPodsRouteRouteWithChildren
  '/_app/profile': typeof AppProfileRouteRoute
  '/_app/settings': typeof AppSettingsRouteRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRouteRouteWithChildren
  '/_auth/signin': typeof AuthSigninRouteRoute
  '/_auth/signup': typeof AuthSignupRouteRoute
  '/goal-invite/$token': typeof GoalInviteTokenRoute
  '/_auth/forgot-password/reset-password': typeof AuthForgotPasswordResetPasswordRouteRoute
  '/_auth/forgot-password/verify-otp': typeof AuthForgotPasswordVerifyOtpRouteRoute
  '/_app/goals/$id': typeof AppGoalsIdRoute
  '/_app/pods/$id': typeof AppPodsIdRoute
  '/_app/users/$userId': typeof AppUsersUserIdRoute
  '/goals/$id/preview': typeof GoalsIdPreviewRoute
  '/_app/goals/': typeof AppGoalsIndexRoute
  '/_app/pods/': typeof AppPodsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/account-deletion'
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/buddy-finder'
    | '/community'
    | '/dashboard'
    | '/messages'
    | '/milestones'
    | '/pods'
    | '/profile'
    | '/settings'
    | '/forgot-password'
    | '/signin'
    | '/signup'
    | '/goal-invite/$token'
    | '/forgot-password/reset-password'
    | '/forgot-password/verify-otp'
    | '/goals/$id'
    | '/pods/$id'
    | '/users/$userId'
    | '/goals/$id/preview'
    | '/goals/'
    | '/pods/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/account-deletion'
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/buddy-finder'
    | '/community'
    | '/dashboard'
    | '/messages'
    | '/milestones'
    | '/profile'
    | '/settings'
    | '/forgot-password'
    | '/signin'
    | '/signup'
    | '/goal-invite/$token'
    | '/forgot-password/reset-password'
    | '/forgot-password/verify-otp'
    | '/goals/$id'
    | '/pods/$id'
    | '/users/$userId'
    | '/goals/$id/preview'
    | '/goals'
    | '/pods'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/onboarding'
    | '/account-deletion'
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/_app/buddy-finder'
    | '/_app/community'
    | '/_app/dashboard'
    | '/_app/messages'
    | '/_app/milestones'
    | '/_app/pods'
    | '/_app/profile'
    | '/_app/settings'
    | '/_auth/forgot-password'
    | '/_auth/signin'
    | '/_auth/signup'
    | '/goal-invite/$token'
    | '/_auth/forgot-password/reset-password'
    | '/_auth/forgot-password/verify-otp'
    | '/_app/goals/$id'
    | '/_app/pods/$id'
    | '/_app/users/$userId'
    | '/goals/$id/preview'
    | '/_app/goals/'
    | '/_app/pods/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRoute
  AccountDeletionRoute: typeof AccountDeletionRoute
  ContactRoute: typeof ContactRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  GoalInviteTokenRoute: typeof GoalInviteTokenRoute
  GoalsIdPreviewRoute: typeof GoalsIdPreviewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-deletion': {
      id: '/account-deletion'
      path: '/account-deletion'
      fullPath: '/account-deletion'
      preLoaderRoute: typeof AccountDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/buddy-finder': {
      id: '/_app/buddy-finder'
      path: '/buddy-finder'
      fullPath: '/buddy-finder'
      preLoaderRoute: typeof AppBuddyFinderRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/community': {
      id: '/_app/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof AppCommunityRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/milestones': {
      id: '/_app/milestones'
      path: '/milestones'
      fullPath: '/milestones'
      preLoaderRoute: typeof AppMilestonesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/pods': {
      id: '/_app/pods'
      path: '/pods'
      fullPath: '/pods'
      preLoaderRoute: typeof AppPodsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/goal-invite/$token': {
      id: '/goal-invite/$token'
      path: '/goal-invite/$token'
      fullPath: '/goal-invite/$token'
      preLoaderRoute: typeof GoalInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/goals/': {
      id: '/_app/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AppGoalsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/goals/$id': {
      id: '/_app/goals/$id'
      path: '/goals/$id'
      fullPath: '/goals/$id'
      preLoaderRoute: typeof AppGoalsIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/pods/': {
      id: '/_app/pods/'
      path: '/'
      fullPath: '/pods/'
      preLoaderRoute: typeof AppPodsIndexRouteImport
      parentRoute: typeof AppPodsRouteRoute
    }
    '/_app/pods/$id': {
      id: '/_app/pods/$id'
      path: '/$id'
      fullPath: '/pods/$id'
      preLoaderRoute: typeof AppPodsIdRouteImport
      parentRoute: typeof AppPodsRouteRoute
    }
    '/_app/users/$userId': {
      id: '/_app/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/forgot-password/reset-password': {
      id: '/_auth/forgot-password/reset-password'
      path: '/reset-password'
      fullPath: '/forgot-password/reset-password'
      preLoaderRoute: typeof AuthForgotPasswordResetPasswordRouteRouteImport
      parentRoute: typeof AuthForgotPasswordRouteRoute
    }
    '/_auth/forgot-password/verify-otp': {
      id: '/_auth/forgot-password/verify-otp'
      path: '/verify-otp'
      fullPath: '/forgot-password/verify-otp'
      preLoaderRoute: typeof AuthForgotPasswordVerifyOtpRouteRouteImport
      parentRoute: typeof AuthForgotPasswordRouteRoute
    }
    '/goals/$id/preview': {
      id: '/goals/$id/preview'
      path: '/goals/$id/preview'
      fullPath: '/goals/$id/preview'
      preLoaderRoute: typeof GoalsIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppPodsRouteRouteChildren {
  AppPodsIdRoute: typeof AppPodsIdRoute
  AppPodsIndexRoute: typeof AppPodsIndexRoute
}

const AppPodsRouteRouteChildren: AppPodsRouteRouteChildren = {
  AppPodsIdRoute: AppPodsIdRoute,
  AppPodsIndexRoute: AppPodsIndexRoute,
}

const AppPodsRouteRouteWithChildren = AppPodsRouteRoute._addFileChildren(
  AppPodsRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppBuddyFinderRouteRoute: typeof AppBuddyFinderRouteRoute
  AppCommunityRouteRoute: typeof AppCommunityRouteRoute
  AppDashboardRouteRoute: typeof AppDashboardRouteRoute
  AppMessagesRouteRoute: typeof AppMessagesRouteRoute
  AppMilestonesRouteRoute: typeof AppMilestonesRouteRoute
  AppPodsRouteRoute: typeof AppPodsRouteRouteWithChildren
  AppProfileRouteRoute: typeof AppProfileRouteRoute
  AppSettingsRouteRoute: typeof AppSettingsRouteRoute
  AppGoalsIdRoute: typeof AppGoalsIdRoute
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppGoalsIndexRoute: typeof AppGoalsIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppBuddyFinderRouteRoute: AppBuddyFinderRouteRoute,
  AppCommunityRouteRoute: AppCommunityRouteRoute,
  AppDashboardRouteRoute: AppDashboardRouteRoute,
  AppMessagesRouteRoute: AppMessagesRouteRoute,
  AppMilestonesRouteRoute: AppMilestonesRouteRoute,
  AppPodsRouteRoute: AppPodsRouteRouteWithChildren,
  AppProfileRouteRoute: AppProfileRouteRoute,
  AppSettingsRouteRoute: AppSettingsRouteRoute,
  AppGoalsIdRoute: AppGoalsIdRoute,
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppGoalsIndexRoute: AppGoalsIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthForgotPasswordRouteRouteChildren {
  AuthForgotPasswordResetPasswordRouteRoute: typeof AuthForgotPasswordResetPasswordRouteRoute
  AuthForgotPasswordVerifyOtpRouteRoute: typeof AuthForgotPasswordVerifyOtpRouteRoute
}

const AuthForgotPasswordRouteRouteChildren: AuthForgotPasswordRouteRouteChildren =
  {
    AuthForgotPasswordResetPasswordRouteRoute:
      AuthForgotPasswordResetPasswordRouteRoute,
    AuthForgotPasswordVerifyOtpRouteRoute:
      AuthForgotPasswordVerifyOtpRouteRoute,
  }

const AuthForgotPasswordRouteRouteWithChildren =
  AuthForgotPasswordRouteRoute._addFileChildren(
    AuthForgotPasswordRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthForgotPasswordRouteRoute: typeof AuthForgotPasswordRouteRouteWithChildren
  AuthSigninRouteRoute: typeof AuthSigninRouteRoute
  AuthSignupRouteRoute: typeof AuthSignupRouteRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRouteRoute: AuthForgotPasswordRouteRouteWithChildren,
  AuthSigninRouteRoute: AuthSigninRouteRoute,
  AuthSignupRouteRoute: AuthSignupRouteRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRoute,
  AccountDeletionRoute: AccountDeletionRoute,
  ContactRoute: ContactRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  GoalInviteTokenRoute: GoalInviteTokenRoute,
  GoalsIdPreviewRoute: GoalsIdPreviewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
